import '@assets/main.css';
import '@/plugins/dayjs';
import { SquirrelPlugin } from '@pequity/squirrel';
import { VueQueryPlugin } from '@tanstack/vue-query';
import FloatingVue from 'floating-vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from '@/App.vue';
import { vPTooltip } from '@/components/p-tooltip/pTooltipDirective';
import { setupAxiosInterceptors } from '@/plugins/axios';
import { i18n, I18nPlugin } from '@/plugins/i18n';
import { setupLayoutComponents } from '@/plugins/layout';
import { ModalPlugin } from '@/plugins/modal';
import { setupObservability } from '@/plugins/observability';
import { ToastPlugin } from '@/plugins/toast';
import { router } from '@/router';

// Set the default distance for all tooltips
FloatingVue.options.themes.tooltip.distance = 12;

const pinia = createPinia();

setupAxiosInterceptors();

const app = createApp(App);

setupLayoutComponents(app);

setupObservability(app, router);

app.use(pinia);

app.use(router);

app.use(VueQueryPlugin, {
  enableDevtoolsV6Plugin: true,
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  },
});

app.use(FloatingVue);

app.use(ToastPlugin(router, i18n));

app.use(ModalPlugin);

app.use(I18nPlugin);

app.use(SquirrelPlugin, i18n);

app.directive('p-tooltip', vPTooltip);

app.mount('#app');
